<template>
  <div>
    <b-modal ref="my-modal" centered hide-footer :title="'Edit Road Tax'">
        <form v-on:submit.prevent="doSubmitRoadTax">
            <label class="labels">Road Tax No. *</label>
            <b-form-input :required="true" for-input="billNumber" type="text" name="billNumber" id="billNumber" label="Bill Number" placeholder="Enter Road Tax No." v-validate="modelValidations.billNumber" :error="errors.first('billNumber')" v-model="model.billNumber" data-vv-as="billNumber"/><br>
            <label class="labels">Expired Date *</label>
            <b-form-datepicker
              id="roadTaxDate"
              name="roadTaxDate"
              :required="true"
              v-model="roadTaxDate"
              aria-required="true"
              v-validate="modelValidations.roadTaxDate"
              v-bind:class="errors.has('roadTaxDate') ? 'is-invalid':''"
              locale="en-US"
              :date-format-options="{ year: 'numeric', day: '2-digit', month: 'long' }"
              placeholder="No Date Selected"
            ></b-form-datepicker><br>
            <label class="labels">Amount *</label>
            <b-form-input :required="true" for-input="amount" type="number" name="amount" id="amount" label="Amount" placeholder="Enter Amount" v-validate="modelValidations.amount" :error="errors.first('amount')" v-model="model.amount" data-vv-as="amount"/><br>
            <!-- <label>Paid Date *</label>
            <b-form-datepicker
              id="paidDate"
              name="paidDate"
              v-model="model.paidDate"
              v-validate="modelValidations.paidDate"
              v-bind:class="errors.has('paidDate') ? 'is-invalid':''"
              locale="en-US"
            ></b-form-datepicker><br> -->
            <label class="labels">bill status *</label>
            <div class="form-group" :required="true" v-bind:class="errors.has('status') ? 'has-error':''">
              <b-form-select name="status" v-model="model.status" v-validate="modelValidations.status" v-bind:class="errors.has('status') ? 'is-invalid':''" :error="errors.first('status')" :options="statusList">
              </b-form-select>
            </div>
            <label class="labels mt-3">Bill Photo </label>
            <div class="expander">
              <!-- <b-form-file v-if="model.status === 'Paid'" :required="true" label="Photo" for-input="photoinputGroupFile" :error="errors.first('photoBill1')" v-model="model.photoBill1">
              </b-form-file> -->
              <b-form-file :required="false" label="Photo" for-input="photoinputGroupFile" :error="errors.first('photoBill1')" v-model="model.photoBill1">
              </b-form-file>
                <!-- <div class="input-group">
                  <div class="custom-file">
                    <b-form-input type="file" class="custom-file-input" ref="photoBill1" @change="onFileSelectedPhoto" id="photoinputGroupFile" accept="image/jpeg, image/png, image/jpg" name="photoBill1" v-validate="modelValidations.photoBill1" :error="errors.first('photoBill1')" data-vv-as="photoBill1"/>
                    <label class="custom-file-label" for="photoinputGroupFile">{{model.photoBill1 !== null ? model.photoBill1.name : 'Choose file'}}</label>
                  </div>
                  <div v-if="model.photoBill1 !== null" class="input-group-append">
                    <span class="input-group-text bg-danger text-white pointer" title="Clear Image" @click="clearImagePhoto"><font-awesome-icon icon="times"/></span>
                  </div>
                </div>
              </b-form-file> -->
            </div><br>
            <!-- <label>Photo Bill 2 *</label>
            <div class="expander">
                <b-form-file :required="true" label="Photo" for-input="photoinputGroupFile" :error="errors.first('photoBill2')" v-model="model.photoBill2">
                    <div class="input-group">
                        <div class="custom-file">
                            <b-form-input type="file" class="custom-file-input" ref="photoBill2" @change="onFileSelectedPhoto" id="photoinputGroupFile" accept="image/jpeg, image/png, image/jpg" name="photoBill2" v-validate="modelValidations.photoBill2" :error="errors.first('photoBill2')" data-vv-as="photoBill2"/>
                            <label class="custom-file-label" for="photoinputGroupFile">{{model.photoBill2 !== null ? model.photoBill2.name : 'Choose file'}}</label>
                        </div>
                        <div v-if="model.photoBill2 !== null" class="input-group-append">
                            <span class="input-group-text bg-danger text-white pointer" title="Clear Image" @click="clearImagePhoto"><font-awesome-icon icon="times"/></span>
                        </div>
                    </div>
                </b-form-file>
            </div><br> -->
            <label class="labels">Note </label>
            <b-form-input :required="false" for-input="note" type="text" name="note" id="note" label="Note" placeholder="Enter Note" v-validate="modelValidations.note" :error="errors.first('note')" v-model="model.note" data-vv-as="note"/><br>
            <b-button variant="warning" class="btn-back float-right" type="submit"><font-awesome-icon icon="save"></font-awesome-icon> Update </b-button>
            <b-button variant="secondary" class="float-left mr-3" @click="hideModal"><font-awesome-icon icon="times-circle"></font-awesome-icon> Cancel</b-button>
        </form>
    </b-modal>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        apiUrl: {
          vehicleBillInfo: window.AppConfig.apiUrl + 'vehicle-bill-info',
        },
        type: null,
        model: {
          uuid: null,
          options: [{
            name: "YearTax",
            value: null
          }],
          dueDate: null,
          type: "Road Tax",
          vehicle: null,
          billNumber: null,
          paidDate: null,
          status: "New",
          amount: 0,
          photoBill1: null,
          photoBill2: null,
          note: "",
        },
        statusList: [
          {
            value: 'New',
            text: 'Waiting For Payment'
          },
          {
            value: 'Paid',
            text: 'Paid'
          }
        ],
        roadTaxDate: null,
        modelValidations: {
          billNumber: {
            required: true
          },
          paidDate: {
            required: true
          },
          amount: {
            required: true
          },
          photoBill1: {
            required: true
          },
          photoBill2: {
            required: true
          },
          status: {
            required: true
          },
          roadTaxDate: {
            required: true
          }
        }
      }
    },
    methods: {
      doSubmitRoadTax() {
        this.$validator.validateAll().then(res => {
          if (res) {
            this.isLoading = true
            // let roadTaxDate = {name: "roadTaxDate", value: this.roadTaxDate};
            // this.model.options.push(roadTaxDate)

            // this.photos = [
            //   {
            //     "photoBillUuid1": this.photo.uuid1,
            //     "photoBill1": this.photo.photoBill1
            //   },
            //   {
            //     "photoBillUuid2": this.photo.uuid2,
            //     "photoBill2": this.photo.photoBill2
            //   }
            // ]

            let formData = new FormData()
            formData.append('billNumber', this.model.billNumber)
            formData.append('amount', this.model.amount)
            formData.append('dueDate', this.roadTaxDate)
            formData.append('status', this.model.status)
            // formData.append('options', JSON.stringify(this.model.options))
            // formData.append('paidDate', this.model.paidDate)
            formData.append('note', this.model.note ? this.model.note : '-')
            if (this.model.photoBill1 !== null) {
              formData.append('photoBill1', this.model.photoBill1)
            }
            // if (this.model.photoBill2 !== null) {
            //   formData.append('photoBill2', this.model.photoBill2, this.model.photoBill2.name)
            // }
            if (this.model.uuid !== null) {
              let model = {}
              Object.keys(this.model).forEach(element => {
                if (element !== 'uuid') {
                    model[element] = this.model[element]
                }
              })
              this.$http.patch(this.apiUrl.vehicleBillInfo + '/' + this.model.uuid, formData).then(response => {
                  this.isLoading = false
                  this.$store.dispatch('notification/success', 'Road Tax successfully updated.')
                  this.hideModal()
                  this.resetData()
                  this.$emit('getRoadTaxBill')
              }).catch(error => {
                  this.isLoading = false
                  this.$store.dispatch('notification/error', error)
              })
            }
          }
        })
      },
      resetData () {
          this.model.uuid = null
          // this.model.paidDate = null
          this.model.photoBill1 = null
          this.roadTaxDate = null
          // this.model.photoBill2 = null
          this.model.note = null
          this.model.status = null
          this.model.amount = 0
          this.model.billNumber = null
          this.$validator.reset()
      },
      showModal(row) {
          this.model.uuid = row.uuid
          this.roadTaxDate = row.dueDate !== null ? this.getDate(row.dueDate) : '-'
          // this.roadTaxDate = row.options !== null ? this.getDate(row.options[0].value) : ''
          // this.model.paidDate = row.paidDate
          this.model.note = row.note !== null && row.note !== '' && row.note !== 'null' ? row.note : '-'
          this.model.amount = row.amount
          this.model.billNumber = row.billNumber
          this.model.status = row.status
          this.$validator.reset();
          this.$refs['my-modal'].show()
      },
      onFileSelectedPhoto (event) {
          this.model.photo = event.target.files[0]
      },
      clearImagePhoto () {
          this.$refs.photoBill1.value = ''
          this.model.photoBill1 = null
          this.$refs.photoBill2.value = ''
          this.model.photoBill2 = null
      },
      hideModal () {
          this.resetData()
          this.$refs['my-modal'].hide()
      },
      getDate (value, format="YYYY-MM-DD") {
        return this.$moment(value).format(format)
      },
    }
  }
</script>